module.exports = __webpack_public_path__ + "img/box-3-zh.d9bd42ab.png";